import { createIndexedDBSuperstore } from 'superstore';
let storeInstance;
export default (() => {
  if (!(storeInstance instanceof Promise)) {
    storeInstance = createIndexedDBSuperstore({
      namespace: 'setup-guide-ui'
    }).open();
  }
  return storeInstance;
});